<script>
  import { Link } from "svelte-routing";
  import TextReveal from "../components/TextReveal.svelte";
  import { copyToClipboard } from "../helper";
  import { onMount } from "svelte";

  export let theme;

  $: welcomeMessage =
    theme === "dark" ? '\'wrong side of the world\' out now ✨' : '\'wrong side of the world\' out now ✨';
</script>

<section
  id="home"
  class="relative main bg-cover bg-center h-screen flex"
  style="background-image: url('/images/background-image2.jpg');"
>
  <div
    data-aos="slide-down"
    data-aos-delay="700"
    data-aos-duration="700"
    class="absolute top-0 right-0 h-1/2 w-full md:w-1/3 md:h-full moving-gradient-1"
  />
 

  <section
    data-aos="fade-in"
    data-aos-delay="600"
    class="m-auto pt-5 relative grow max-w-5xl"
  >
    <div
      class="bg-white dark:bg-gray-900 px-5 py-10 lg:py-14 lg:px-10 shadow-2xl flex items-center justify-between"
    >
      <div class="content">
        <div
          data-aos="flip-up"
          data-aos-delay="600"
          data-aos-duration="700"
          class="bg-purple-400 dark:bg-purple-300 shadow-purple-300/60 shadow-lg w-8 h-1.5 lg:w-10 lg:h-2 ml-0.5 mb-6"
        >
      
        </div>
        <h1
          class="mb-3 md:mb-6 font-mono font-black text-2xl md:text-3xl lg:text-5xl text-gray-700 dark:text-white"
        >
          <TextReveal delay={800} once text={welcomeMessage} />
        </h1>
        <p
          class="text-lg md:text-xl lg:text-xl mb-8 font-bold text-gray-500 dark:text-gray-400 ml-1"
        >
          <TextReveal
            delay={1000}
            once
            text="Melodic EDM artist from London 💫"
          />
        </p>

        <div
          data-aos="fade-left"
          data-aos-delay="1200"
          data-aos-duration="700"
          class="text-sm text-gray-700 font-semibold font-mono"
        >
          <a
          href="https://open.spotify.com/album/0O0fefmUNGKHM2VSx7cBIA?si=cd32b49bdc8a4dc6"
          class="transition-colors px-4 py-1 inline-block bg-red-200 shadow-purple-300/20 shadow-lg hover:bg-red-300 rounded-sm border border-red-400"
          >Stream 'Wrong Side Of The World' ✨</a
        >
          <a
            href="https://open.spotify.com/artist/5k013eqGq6R7I8hYIqB643?si=108df49218544ada"
            class="transition-colors px-4 py-1 inline-block bg-blue-200 shadow-purple-300/20 shadow-lg hover:bg-blue-300 rounded-sm border border-blue-400"
            >Spotify</a
          >
          <a
            href="https://www.instagram.com/shxdowmusic/"
            class="transition-colors px-4 py-1 inline-block bg-blue-200 shadow-purple-300/20 shadow-lg hover:bg-blue-300 rounded-sm border border-blue-400"
            >Instagram</a
          >
          <a
            href="https://www.youtube.com/channel/UCsxTK4CvPbkteUNcnwvk2nw"
            class="transition-colors px-4 py-1 inline-block bg-blue-200 shadow-purple-300/20 shadow-lg hover:bg-blue-300 rounded-sm border border-blue-400"
            >Youtube</a
          >
          <a
            href="https://www.tiktok.com/@shxdowmusicofficial?lang=en"
            class="transition-colors px-4 py-1 inline-block bg-blue-200 shadow-purple-300/20 shadow-lg hover:bg-blue-300 rounded-sm border border-blue-400"
            >TikTok</a
          >
        
          <a
            href="/#contact"
            class="transition-colors px-4 py-1 inline-block bg-blue-200 shadow-purple-300/20 shadow-lg hover:bg-blue-300 rounded-sm border border-blue-400"
            >Contact me</a
          >
        </div>
      </div>
      <div class="image-container">
        <img src="/images/shxdow.png" alt="Your Description" class="profile-image"/>
      </div>
    </div>
  </section>

  <div
    data-aos="slide-up"
    data-aos-delay="1500"
    data-aos-duration="700"
    class="hidden text-xl absolute lg:flex flex-col gap-4 items-center w-4 left-14 bottom-0 text-center text-gray-700 dark:text-gray-50"
  >
    <a
      title="Stream my music on Spotify"
      aria-label="Stream my music on Spotify"
      href="https://open.spotify.com/artist/5k013eqGq6R7I8hYIqB643?si=108df49218544ada"
      target="_blank"
      class="block"><i class="fab fa-spotify" /></a
    >
    <a
      title="Follow me on IG"
      aria-label="Follow me on IG"
      href="https://www.instagram.com/shxdowmusic/"
      target="_blank"
      class="block"
    >
      <i class="fab fa-instagram" /></a
    >
    <a
      title="Subscribe to my Youtube channel"
      aria-label="Subscribe to my Youtube channel"
      href="https://www.youtube.com/channel/UCsxTK4CvPbkteUNcnwvk2nw"
      target="_blank"
      class="block"
    >
      <i class="fab fa-youtube" /></a
    >
    <a
      title="Follow me on TikTok"
      aria-label="Follow me on Tiktok"
      href="https://www.tiktok.com/@shxdowmusicofficial?lang=en"
      target="_blank"
      class="block"
    >
      <i class="fab fa-tiktok" /></a
    >
    <a
      title="Follow me on Soundcloud"
      aria-label="Follow me on Soundcloud"
      href="https://www.soundcloud.com/shxdowmusic"
      target="_blank"
      class="block"
    >
      <i class="fab fa-soundcloud" /></a
    >
    

    <a
      title="Send me an email"
      aria-label="Send me an email"
      href="mailto:shxdowmusic281@gmail.com"
      target="_blank"
      class="block"
    >
      <i class="far fa-envelope" />
    </a>

    <!-- <a href="https://codepen.io/bobshoaun" target="_blank" class="block mb-8"
    ><i class="fab fa-codepen fa-lg" /></a
  > -->

    <div class="shadow-xl w-4 h-28 bg-gray-700 dark:bg-gray-50" />
  </div>

  <button
    title="Go to about me"
    aria-label="Go to about me"
    data-aos="fade-down"
    data-aos-delay="1500"
    data-aos-duration="700"
    on:click={() => document.getElementById("about").scrollIntoView()}
    class="group text-xl lg:text-3xl py-5 text-gray-700 dark:text-white absolute w-14 mx-auto text-center bottom-20 right-0 left-0"
  >
    <i class="hover-vertical fas fa-angle-down group-hover:pause" />
  </button>
</section>

<style>
  .main {
    background-size: cover;
    background-position: center;
  }
  .content {
    flex: 1;
  }

  .image-container {
    flex-shrink: 0;
    margin-left: 20px; /* Adjust this value as needed */
  }

  .profile-image {
    width: 150px; /* Adjust this value as needed */
    height: auto;
    border-radius: 0%; /* Optional: makes the image circular */
  }
</style>
